<ul role="menubar" aria-orientation="vertical" [attr.aria-label]="'header.navigation.aria-label' | translate">
    @for (item of menuItems(); track $index + item.label) {
        <li role="none">
            <app-menu-item [item]="item" />
        </li>
    }

    @if (daysInARow(); as days) {
        <li role="none">
            <app-learning-streak [days]="days" />
        </li>
    }

    @for (item of bottomMenuItems(); track $index + item.label) {
        <li role="none" [class.first-bottom-item]="$first" [class.last-bottom-item]="$last">
            <app-menu-item [item]="item" severity="secondary" />
        </li>
    }

    <li role="none">
        <app-profile />
    </li>
</ul>
